import React from "react";
import { Typography, withStyles } from "@material-ui/core";
import PlanningFormContainer from "../shared/planningForm/planningFormContainer";
import { usePlanningPlanDataForm } from "features/planning/hooks/usePlanningDataForm";
import { useGoalValidations } from "features/planning/hooks/useGoalValidations";
import usePlanningRegisterTable from "features/planning/hooks/usePlanningRegisterTable";
import ConfirmationModal from "features/shared/components/confirmationModal";
import { useTranslations, Trans } from "adapters/i18n";

const PlanningRegisterPage = ({
  classes,
  farmId,
  enableLoading,
  disableLoading,
  notifyError,
  onSubmit = () => {},
  goBack = () => {},
}) => {
  const { t } = useTranslations();
  const SubTitle = () => (
    <Typography className={classes.subtitle}>
      <Trans
        i18nKey="planning:register.subtitle"
        components={{ span: <span className={classes.subTitleHighlight} /> }}
      />
    </Typography>
  );

  const IngredientSubTitle = () => (
    <Typography className={classes.subtitle}>
      {t("planning:register.ingredient-info")}
    </Typography>
  );

  const SummarySubTitle = () => (
    <Typography className={classes.subtitle}>
      <Trans
        i18nKey="planning:register.summary-info"
        components={{ span: <span className={classes.subTitleHighlight} /> }}
      />
    </Typography>
  );

  const { planningPlanData, periodTitles, onChangePlanningInitialDate } =
    usePlanningPlanDataForm();

  const {
    freeCategories,
    categories,
    formulas,
    formulasIngredients,
    planningsTableList,
    planningList,
    ingredientsPrices,
    summaryReport,
    updateIngredientsList,
    onChangeCategory,
    onChangeFormula,
    onChangeHerdCount,
    onChangeIngredientPrice,
    addNewLine,
    onDeleteLine,
    updateSummaryReport,
  } = usePlanningRegisterTable(
    farmId,
    enableLoading,
    disableLoading,
    notifyError
  );

  const { modalDatePickerActiveGoalPeriod: modalActiveGoalPeriod } =
    useGoalValidations({
      farmId,
      enableLoading,
      disableLoading,
      planningPlanDataInitialDate: planningPlanData.initialDate,
      onChangePlanningInitialDate,
    });

  const handleOnSubmit = () =>
    onSubmit({
      ...planningPlanData,
      planningList,
      ingredientsPrices,
      summaryReport,
      formulas,
      categories,
    });

  const handleOnChangePlanningInitialDate = (value) => {
    onChangePlanningInitialDate(value);
    modalActiveGoalPeriod.onChangeInitialDate();
  };
  return (
    <>
      <PlanningFormContainer
        title={t("planning:register.title")}
        subtitle={<SubTitle />}
        ingredientsSubtitle={<IngredientSubTitle />}
        summarySubTitle={<SummarySubTitle />}
        planningPlanData={planningPlanData}
        periodTitles={periodTitles}
        freeCategories={freeCategories}
        categories={categories}
        ingredientsPrices={ingredientsPrices}
        formulas={formulas}
        formulasIngredients={formulasIngredients}
        planningsTableList={planningsTableList}
        onChangeCategory={onChangeCategory}
        onChangeFormula={onChangeFormula}
        onChangeHerdCount={onChangeHerdCount}
        onChangeIngredientPrice={onChangeIngredientPrice}
        updateIngredientsList={updateIngredientsList}
        addNewLine={addNewLine}
        onDeleteLine={onDeleteLine}
        onChangePlanningInitialDate={handleOnChangePlanningInitialDate}
        interceptDatePicker={modalActiveGoalPeriod.interceptDatePicker}
        showDatePicker={modalActiveGoalPeriod.showDatePicker}
        setShowDatePicker={modalActiveGoalPeriod.setShowDatePicker}
        onClickInitialDate={modalActiveGoalPeriod.openModal}
        onSubmit={handleOnSubmit}
        goBack={goBack}
        updateSummaryReport={updateSummaryReport}
        summaryReport={summaryReport}
      />

      {modalActiveGoalPeriod.modalGoalsDateSuggest && (
        <ConfirmationModal
          title={t("planning:register.modal.title")}
          text={modalActiveGoalPeriod.getActiveGoalPeriodMessage()}
          cancelButtonTitle={t("planning:register.modal.cancel")}
          submitButtonTitle={t("planning:register.modal.submit")}
          onSubmit={modalActiveGoalPeriod.onConfirmGoalPeriodDate}
          onCancel={modalActiveGoalPeriod.onCancelGoalPeriodDate}
        />
      )}
    </>
  );
};
const styles = (theme) => ({
  subtitle: {
    margin: "25px 0 12px 0",
    fontFamily: "Roboto",
    fontSize: "14px",
    lineHeight: "normal",
    letterSpacing: "0.2px",
    textAlign: "left",
    color: "#616161",
  },
  subTitleHighlight: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },
});
export default withStyles(styles)(PlanningRegisterPage);
